module.exports = __webpack_public_path__ + "img/salammall1.145e8b57.jpeg";